export default () => {
    return useCookie('_lb', {
        maxAge: 31536000, // 365 days
        secure: true,
    })
}
